import { useEffect, useState } from 'react';

// Custom Hook
const useDeviceType = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Considera dispositivos móveis com largura até 768px
    };

    handleResize(); // Verifica o tamanho da tela no primeiro render

    window.addEventListener('resize', handleResize); // Atualiza ao redimensionar a tela
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};

export default useDeviceType;
